import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import { GetJutgeProblemesId } from "../../../../dao/jutge/GetJutgeProblemesId";
import { message, Tooltip } from "antd";
import { CopyOutlined, LoginOutlined, LogoutOutlined } from "@ant-design/icons";

interface Props {
    propIdProblema?: string;
    propIdActivitat?: string;
}

// Targeta d'exemple (entrada o sortida) amb capçalera, monospace i botó de copiar.
const ExempleCard: React.FC<{
    title: string;
    value?: string;
    icon: React.ReactNode;
    accent: string;
    emptyText: string;
}> = ({ title, value, icon, accent, emptyText }) => {
    const hasData = value !== undefined && value !== null && value !== '';

    const copy = () => {
        if (!hasData) return;
        navigator.clipboard.writeText(value as string)
            .then(() => message.success('Copiat!'))
            .catch(() => message.error('No s\'ha pogut copiar'));
    };

    return (
        <div
            style={{
                flex: 1,
                minWidth: 240,
                background: '#fff',
                border: '1px solid #eef0f2',
                borderRadius: 12,
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {/* Capçalera */}
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '10px 14px',
                    background: accent,
                    color: '#fff',
                }}
            >
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontWeight: 600, fontSize: 13 }}>
                    {icon} {title}
                </span>
                {hasData && (
                    <Tooltip title="Copiar">
                        <CopyOutlined
                            onClick={copy}
                            style={{ cursor: 'pointer', opacity: 0.9 }}
                        />
                    </Tooltip>
                )}
            </div>

            {/* Contingut */}
            <pre
                style={{
                    margin: 0,
                    padding: '14px 16px',
                    fontFamily: "'Fira Code', 'Consolas', monospace",
                    fontSize: 13,
                    lineHeight: 1.5,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    color: hasData ? '#2f3b33' : '#9aa0a6',
                    fontStyle: hasData ? 'normal' : 'italic',
                    background: '#fafbfc',
                    flex: 1,
                    minHeight: 48,
                }}
            >
                {hasData ? value : emptyText}
            </pre>
        </div>
    );
};

const ProblemaIdExemples: React.FC<Props> = ({ propIdProblema, propIdActivitat }) => {
    const { isLoggedIn } = useContext(AuthContext);
    const params = useParams();
    const id_problema = propIdProblema || params.id_problema;
    const id_activitat = propIdActivitat || params.id_activitat;
    const [dades, setDades] = useState<any>();

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [id_problema]);

    async function checkDades() {
        setDades(await GetJutgeProblemesId(id_problema + "", id_activitat || "0"));
    }

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
            <ExempleCard
                title="Exemple d'entrada"
                value={dades?.entrada}
                icon={<LoginOutlined />}
                accent="#527e4c"
                emptyText="No hi ha dades d'entrada"
            />
            <ExempleCard
                title="Exemple de sortida"
                value={dades?.sortida}
                icon={<LogoutOutlined />}
                accent="#285a4a"
                emptyText="No hi ha dades de sortida"
            />
        </div>
    );
};

export default ProblemaIdExemples;
